import { ModalActionDef, ModalDefine, ModalStatus } from '@/libs/formHelper/modalForm/type'
import { Spouse } from '@/api/spouse/Spouse'

export default function getModalDefine (view: any): ModalDefine<Spouse> {
  const items = [{
    title: '图片',
    type: {
      module: 'imageUrl'
    },
    key: 'picture'
  }, {
    title: '姓名',
    required: true,
    key: 'name'
  }, {
    title: '是否离异',
    col: { span: 12 },
    required: true,
    key: 'isDivorce',
    type: {
      module: 'radio',
      options: [
        { id: 0, name: '否' },
        { id: 1, name: '是' }
      ]
    }
  }, {
    title: '是否丧偶',
    required: true,
    key: 'isBereave',
    col: { span: 12 },
    type: {
      module: 'radio',
      options: [
        { id: 0, name: '否' },
        { id: 1, name: '是' }
      ]
    }
  }]

  const actions: ModalActionDef<Spouse>[] = [{
    key: 'create',
    title: '创建',
    type: 'submit',
    button: 'success',
    actionClose: true,
    modalStatus: ModalStatus.ADD,
    onClick: (item: Spouse) => {
      return view.onInsertItem(item)
    }
  }, {
    key: 'modi',
    title: '保存',
    type: 'submit',
    button: 'success',
    actionClose: true,
    modalStatus: ModalStatus.MODI,
    onClick: (item: Spouse) => {
      return view.onUpdateItem(item)
    }
  }]

  return {
    items,
    actions
  }
}
